import { Box, CircularProgress, CssBaseline } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import React from "react";
import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
} from "react-router-dom";
import { AppProviders } from "./AppProviders";
import { useAuth } from "./data/providers/AuthProvider";
import { UserDataProvider } from "./data/providers/UserDataProvider";
import AdminPaymentsPage from "./pages/AdminPaymentsPage";
import AdminPlansPage from "./pages/AdminPlansPage";
import AdminUsersPage from "./pages/AdminUsersPage";
import AnalyticsPage from "./pages/AnalyticsPage";
import Dashboard from "./pages/Dashboard";
import LoginPage from "./pages/LoginPage";
import PlanPage from "./pages/PlanPage";
import ProfilePage from "./pages/ProfilePage";
import PrivateRoute from "./routes/PrivateRoute";
import darkTheme from "./theme";

const App: React.FC = () => {
  const { loading } = useAuth();

  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />
      {loading ? (
        <Box
          sx={{
            minHeight: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            bgcolor: "#f5f6fa",
          }}
        >
          <CircularProgress size={48} color="primary" />
        </Box>
      ) : (
        <AppProviders>
          <Router>
            <Routes>
              <Route path="/" element={<Navigate to="/login" replace />} />
              <Route path="/login" element={<LoginPage />} />
              <Route
                element={
                  <UserDataProvider>
                    <PrivateRoute />
                  </UserDataProvider>
                }
              >
                <Route path="/dashboard" element={<Dashboard />}>
                  <Route path="/dashboard/plan" index element={<PlanPage />} />
                  <Route path="profile" element={<ProfilePage />} />

                  {/* Admin */}
                  <Route path="" element={<AnalyticsPage />} />
                  <Route
                    path="admin/payments"
                    element={<AdminPaymentsPage />}
                  />
                  <Route path="admin/users" element={<AdminUsersPage />} />
                  <Route path="admin/plans" element={<AdminPlansPage />} />
                </Route>
              </Route>
            </Routes>
          </Router>
        </AppProviders>
      )}
    </ThemeProvider>
  );
};

export default App;
